(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * HotelMap GTagging Setup.
 *
 * Implements the google tag manager for event based actions within
 * HotelMap
 */
window.tagging = require("./modules/gtag");

/*
Available Event Methods
=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
window.tagging.setCalendarActive
window.tagging.setSearchRunning
window.tagging.setHasActionedZoom
window.tagging.setHotelClicked
window.tagging.setHotelPopup
window.tagging.setChatClicked
window.tagging.setMapMoved
window.tagging.setHotelSummary
window.tagging.setHotelFacilities
window.tagging.setHotelReviews
window.tagging.setHotelPictures
*/

},{"./modules/gtag":2}],2:[function(require,module,exports){
/**
 * Google Tagging Experiments for IOE and Venues within Analytics.
 *
 * See: https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
module.exports = {

    /**
     * <bool> debug_on - Is the debug mode on
     */
    debug_on: false,

    /**
     * Is the TAGGING enabled?
     *
     * @return <bool>
     */
    isTagEnabled: function () {
        return window && window.gtag && typeof gtag === "function" && window && window.attributes && window.attributes.enabledGoogleTagging;
    },

    /**
     * Build our category and label mechanism
     *
     */
    getCategorySettings: function () {
        if (window && window.attributes) {
            if (window.attributes.enabledIOETagging == '1') {
                return {
                    'event_category': 'IOE',
                    'event_label': 'HotelMap'
                };
            } else if (window.attributes.enabledVenueTagging == '1') {
                return {
                    'event_category': 'VENUE',
                    'event_label': 'HotelMap'
                };
            }
        }
    },

    /**
     * Debug message to the screen
     *
     * @param <string> message
     */
    debug: function (message) {
        if (message && this.debug_on == true) {
            console.log(message);
        }
    },

    /**
     * Map Action events to be sent to gtag
     *
     */

    setBookingPage: function () {
        if (this.isTagEnabled()) {
            this.debug("Booking Page is set active");
            gtag('event', 'booking_page', this.getCategorySettings());
        }
    },

    setCalendarActive: function () {
        if (this.isTagEnabled()) {
            this.debug("Calendar is set active");
            gtag('event', 'calendar_processed', this.getCategorySettings());
        }
    },

    setSearchRunning: function () {
        if (this.isTagEnabled()) {
            this.debug("Search is set active");
            gtag('event', 'search_running', this.getCategorySettings());
        }
    },

    setHasActionedZoom: function () {
        if (this.isTagEnabled()) {
            this.debug("Zoom is set active");
            gtag('event', 'zoom_action', this.getCategorySettings());
        }
    },

    setHotelClicked: function () {
        if (this.isTagEnabled()) {
            this.debug("Hotel Clicked is set active");
            gtag('event', 'hotel_clicked', this.getCategorySettings());
        }
    },

    setHotelPopup: function () {
        if (this.isTagEnabled()) {
            this.debug("Hotel Pop is set active");
            gtag('event', 'hotel_popup', this.getCategorySettings());
        }
    },

    setChatClicked: function () {
        if (this.isTagEnabled()) {
            this.debug("Chat is set active");
            gtag('event', 'chat_clicked', this.getCategorySettings());
        }
    },

    setMapMoved: function () {
        if (this.isTagEnabled()) {
            this.debug("Map Moved is set active");
            gtag('event', 'map_moved', this.getCategorySettings());
        }
    },

    setHotelSummary: function () {
        if (this.isTagEnabled()) {
            this.debug("Summary is set active");
            gtag('event', 'hotel_popup_summary', this.getCategorySettings());
        }
    },

    setHotelFacilities: function () {
        if (this.isTagEnabled()) {
            this.debug("Favilities is set active");
            gtag('event', 'hotel_popup_facilities', this.getCategorySettings());
        }
    },

    setHotelReviews: function () {
        if (this.isTagEnabled()) {
            this.debug("Reviews is set active");
            gtag('event', 'hotel_popup_reviews', this.getCategorySettings());
        }
    },

    setHotelPictures: function () {
        if (this.isTagEnabled()) {
            this.debug("Pictures is set active");
            gtag('event', 'hotel_popup_pictures', this.getCategorySettings());
        }
    },

    setHotelRates: function () {
        if (this.isTagEnabled()) {
            this.debug("Rates is set active");
            gtag('event', 'hotel_popup_rates', this.getCategorySettings());
        }
    }
};

},{}]},{},[1]);
